import Mixpanel from 'common/services/stats/-RFC.Mixpanel';

const _directiveDependencies = [];
const _controllerDependencies = ['$scope'];

class LatestNewsController {

    constructor($scope) {

        $scope.brandName = CWCONFIG.partnerConfig.name;
        $scope.sendSupportMixpanel = (buttonLabel) => {

            Mixpanel.send('ConnectWeb Home Click', {
                Label: 'Support',
                'Button label': buttonLabel,
            });

        };

    }

}


class SupportDirective {

    constructor() {

        this.template = require('./support.html');
        this.restrict = 'EA';
        this.replace = true;

        _controllerDependencies.push($scope =>
            new LatestNewsController($scope));
        this.controller = _controllerDependencies;
        this.controllerAs = 'latestNewsCtrl';

    }

}

_directiveDependencies.push(() => new SupportDirective());


angular.module('directives')
    .directive('support', _directiveDependencies);



// WEBPACK FOOTER //
// ./scripts/directives/dashboard/support/support.js